import { React, useState, useEffect } from 'react'
// import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { useParams, } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock, faLocationDot, faEnvelope, faPhone, faGlobe, faBuilding, faList, faScaleBalanced, faCalendarPlus, faChampagneGlasses, faUsers } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import ScheduleDutyCard from '../../../components/ScheduleDutyCard/ScheduleDutyCard.js'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, formatScheduleDayWithWeekday } from '../../../main.js'

import '../../../main.css'
import './EventRegisteredSchedule.css'
import './MEventRegisteredSchedule.css'

import img_not_found from '../../../assets/pictures/imgnotfound.webp'


import Cookies from 'universal-cookie'

export default function EventRegisteredSchedule() {

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    const { eventid } = useParams();
    var [eventFound, setEventFound] = useState(1)
    var [resError, setResError] = useState("")

    var [eventRegistered, setEventRegistered] = useState(0)
    var [eventScheduleRegistered, setEventScheduleRegistered] = useState(0)

    var [formError, setFormError] = useState(false)

    var [scheduleFormData, setScheduleFormData] = useState({ a: 0 })
    var [registeredCompanions, setRegisteredCompanions] = useState([])

    var [eventData, setEventData] = useState({
        eventId: "",
        eventOrgId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventImprintURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationEnd: "",
            applicationStart: "",
        },
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })

    var [eventScheduleData, setEventScheduleData] = useState({
        eventId: "0",
        dates: [
            {
                day: "01.01.1900",
                schedules: [
                    {
                        scheduleElementId: "0",
                        title: "Beispiel",
                        startTime: "00:00",
                        endTime: "23:59",
                        description: "Beispielzeitraum",
                        location: "",
                        dutys: [
                            {
                                dutyId: "0",
                                title: "Beispieldienst",
                                description: "Dies ist ein Beispiel",
                                maxPersons: 0,
                                currentPersons: 0,
                                isFull: 0,
                                selection: 0
                            },
                        ]
                    },
                ]
            },
        ]
    });


    useEffect(() => {

        // setCur_userid(cookies.get('userid'))

        if (eventid == "0" || eventid == null) { } else {
            getEventData()
            getEventRegistered()
            getEventScheduleData()
        }

        const listener = event => {

            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // setFormUsername(document.querySelector('.in_username').value)
                // setFormPassword(document.querySelector('.in_password').value)
                // doLogin()
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])

    function getEventData() {

        try {
            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setEventFound(0)
                }
            })
            )

        } catch (err) {
            setEventFound(0)
        }

    }

    function applyEventData(metadata) {


        setEventData({
            eventId: metadata._id,
            eventOrgId: (metadata.organization && metadata.organization._id) ? String(metadata.organization._id) : (metadata.orgid ? String(metadata.orgid) : ""),
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }

    }

    function getEventRegistered() {

        try {

            fetch(URL_MAINAPI + "/user/attend/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    if (!res.data.eventregistered) lP("/event/" + eventid)
                    if (!res.data.eventscheduleregistered) lP("/eventregisterschedule/" + eventid)
                    //TODO Errorhandling
                    setEventRegistered(res.data.eventregistered ? 1 : 0)
                    setEventScheduleRegistered(res.data.eventscheduleregistered ? 1 : 0)



                } else {
                    setEventRegistered(0)
                    setEventScheduleRegistered(0)
                }
            })
            )

        } catch (err) {
            setEventRegistered(0)
            setEventScheduleRegistered(0)
        }

    }

    function getEventScheduleData() {
        try {
            fetch(URL_MAINAPI + "/eventscheduleregister/userregisteredschedule/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setEventFound(1)
                    applyEventSchedulaData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setEventFound(0)
                }
            })
            )

        } catch (err) {
            setEventFound(0)
        }

    }

    function applyEventSchedulaData(scheduledata) {
        // console.log(scheduledata.dates[0].day);
        setRegisteredCompanions(scheduledata.companions || [])
        setEventScheduleData({
            eventId: scheduledata.eventid,
            dates: scheduledata.dates.map(date => ({
                day: date.day,
                schedules: date.schedules.map(schedule => ({
                    scheduleElementId: schedule._id,
                    title: schedule.title,
                    startTime: schedule.startTime,
                    endTime: schedule.endTime,
                    description: schedule.description,
                    location: schedule.location,
                    dutys: schedule.dutys.map(duty => ({
                        dutyId: duty._id,
                        title: duty.title,
                        description: duty.description,
                        maxPersons: duty.maxPersons,
                        currentPersons: duty.currentPersons,
                        isFull: duty.isFull,
                        selection: duty.selection
                        //DONE check for in backend
                        // currentPersons: 0,
                        // isFull: 0,
                    }))
                }))
            }))
        });

    }

    function doUnattend(eventid) {
        if (!window.confirm("Möchtest du wirklich absagen? Kontaktiere ggf. vorher den Veranstalter")) return

        try {
            fetch(URL_MAINAPI + "/user/unattend/" + eventid, {
                method: "DELETE",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    window.location.href = "/event/" + eventid;
                } else {
                    window.location.reload()
                }
            })
            )

        } catch (err) {


        }
    }


    if (eventid == "0" || eventid == null || eventFound == 0) {

        return (
            <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon_registerschedule'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Eventzeitplan</title>
                    <meta name="robots" content="noindex" />

                </Helmet>

                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card error-card'>
                                <h3>Das gesuchte Event wurde nicht gefunden!</h3>
                                <p>Bitte kehre zur vorigen Seite zurück. Oder versuche den Veranstalter zu kontaktieren.</p><br />
                                <CTAButton variant="primary" hideArrow={true} title={"Startseite"} onclick={() => lP('/')}></CTAButton>
                            </div>
                        </motion.div>
                    </div>
                </main>

                < MainFooter useEventStyle={true} />
            </div >
        );
    }


    return (
        <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon_registerschedule'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Eventzeitplan: {eventData.eventName}</title>
                <meta property="og:title" content={"Zeitplan für Helferzeit-Event: " + eventData.eventName} />
                <meta property="og:description" content={"Melde dich hier für die Dienste der Veranstaltung an: " + eventData.eventLongName + ""} />
                <meta name="robots" content="noindex" />

            </Helmet>

            <div className='eventbar'>
                <div className='eventbar-inner'>
                    <motion.img variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} alt='Logo des Veranstalters bzw. der Organisation' className='eventbar-logo' src={eventData.eventLogo} onClick={() => oP(eventData.eventURL)}></motion.img>
                    <motion.h2 variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='eventbar-name' onClick={() => lP('/event/' + eventid)} style={{ cursor: "pointer" }}>{eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}</motion.h2>
                </div>
            </div>

            <main className='page-body'>
                <section className='container section' style={{ paddingTop: '40px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card schedule-card'>
                            {(!eventScheduleRegistered) ? <div className="schedule_cont">

                                <h2>Du bist noch nicht für dieses Event eingetragen!</h2>

                            </div> :

                                <div className='schedule_cont'>
                                    <h2>Deine eingereichten Dienste</h2>
                                    <p className='registeredschedule_info'>Für folgende Dienste hast du dich gemeldet. Beachte, dass die Veranstalter dich erst noch final in die Dienste einteilen müssen.<br />Deinen tatsächlichen Dienstplan findest du - sobald verfügbar - unter <a href={'/eventplannedschedule/' + eventid}>Mein Dienstplan</a>.</p>

                                    {(registeredCompanions.length > 0) ? (
                                        <div className='schedule_companions_readonly'>
                                            <p className='schedule_companions_readonly_title'>
                                                Mitgebrachte Personen ({registeredCompanions.length})
                                            </p>
                                            <ul className='schedule_companions_readonly_list'>
                                                {registeredCompanions.map(function (companion, index) {
                                                    return (
                                                        <li key={'reg_companion_' + index}>
                                                            +{index + 1} {companion.firstname} {companion.lastname}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                            <p className='schedule_companions_readonly_hint'>
                                                Diese Personen teilen deine Wunschdienste.
                                            </p>
                                        </div>
                                    ) : null}

                                    <div className='schedule_dates_list'>
                                        {eventScheduleData.dates.map(function (scheduledates) {
                                            console.log(scheduledates.schedules);

                                            return (

                                                <div className='schedule_date'>
                                                    <h3><FontAwesomeIcon icon={faCalendarDays} /> {formatScheduleDayWithWeekday(scheduledates.day)}</h3>
                                                    <div className='schedule_scheduleelement_list'>
                                                        {scheduledates.schedules.map(function (scheduleelement) {
                                                            return (
                                                                <div className='schedule_scheduleelement'>
                                                                    <h4><FontAwesomeIcon icon={faClock} /> {scheduleelement.startTime} - {scheduleelement.endTime} <br className='m_break' />→ {scheduleelement.title}</h4>
                                                                    <p className='schedule_scheduleelement_desc'><FontAwesomeIcon icon={faLocationDot} /> {scheduleelement.location}<br />{scheduleelement.description}</p>
                                                                    <div className='schedule_dutys_list'>
                                                                        {scheduleelement.dutys.map(function (dutyelement) {
                                                                            if (dutyelement.selection == 1 || dutyelement.selection == 2) {
                                                                                return (
                                                                                    <ScheduleDutyCard title={dutyelement.title} description={dutyelement.description} isFull={(dutyelement.selection == 2) ? 1 : 0} editable={false} value={(dutyelement.selection != 0) ? 1 : 0} onclick={() => { }} />
                                                                                );
                                                                            } else {
                                                                            }
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <p className='schedule_info'>
                                        Wichtig: Dies ist eine Vorauswahl. Die Veranstalter ändern ggf. die Dienste in Absprache mit dir nochmal ab.<br />
                                        Du kannst deine Angaben zur besseren Planbarkeit nach dem Abschicken nicht nochmal abändern. Für Fragen und Änderungen kontaktierst du bitte den Veranstalter.<br /><br />
                                        <font>
                                            Du kannst deine Anmeldung zum Event zurückziehen. Beachte, dass dies unwiderruflich ist. Falls du deine Meinung änderst, musst du dich komplett neu für das Event anmelden.&nbsp;
                                            <a href="#" onClick={() => doUnattend(eventid)}>Absagen</a>

                                        </font>
                                    </p>

                                </div>
                            }
                        </div>
                    </motion.div>
                </section>

                <section className='container section' style={{ paddingTop: '8px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <div className='card info-card'>
                            <div className='eventinfo_box'>
                                <h2>{eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarPlus} /><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarDays} /><b>Veranstaltung</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faChampagneGlasses} /><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faUsers} /><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p>{eventData.eventInfo.box3Text}</p>
                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelope} /> {eventData.eventContactMail}</a> : null}
                                    {(eventData.eventContactTel != "") ? <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faPhone} /> {eventData.eventContactTel}</a> : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> Webseite des Veranstalters</a>
                                    <a href={eventData.eventImprintURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faScaleBalanced} /> Impressum des Veranstalters</a>
                                    <a><FontAwesomeIcon icon={faBuilding} /> Veranstalter: {eventData.eventOrganizator}</a>
                                    {(eventData.eventOrgId) ? <a href={'/events/public/' + eventData.eventOrgId} className="eventinfo_link_eventlist" onClick={(e) => { e.preventDefault(); lP('/events/public/' + eventData.eventOrgId); }}><FontAwesomeIcon icon={faList} /> Weitere öffentliche Events dieser Organisation</a> : null}
                                </div>
                                <CTAButton variant="secondary" size="sm" hideArrow={true} title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)}></CTAButton>
                                <br /><br /><br />
                            </div>
                        </div>
                    </motion.div>

                </section>
            </main>

            < MainFooter useEventStyle={true} />
        </div >
    )
}
